import React from 'react'
import { ShieldX, ArrowLeft } from 'lucide-react'
import { Button } from '@diversioteam/diversio-ds'

import * as S from './AccessDenied.styles'

interface IAccessDeniedProps {
    title?: string
    message?: string
    showBackButton?: boolean
    onBack?: () => void
}

export function AccessDenied({
    title = 'Access Denied',
    message = "You don't have permission to access this resource. Please contact your administrator to set up your role permissions.",
    showBackButton = true,
    onBack,
}: IAccessDeniedProps) {
    const handleBack = () => {
        if (onBack) {
            onBack()
        } else {
            window.history.back()
        }
    }

    return (
        <S.Container>
            <S.Card>
                <S.IconWrapper>
                    <ShieldX size={48} />
                </S.IconWrapper>

                <S.Content>
                    <S.Title>{title}</S.Title>
                    <S.Message>{message}</S.Message>
                </S.Content>

                {showBackButton && (
                    <S.Actions>
                        <Button onClick={handleBack} color="primary" size="medium">
                            <ArrowLeft size={16} style={{ marginRight: '8px' }} />
                            Go Back
                        </Button>
                    </S.Actions>
                )}
            </S.Card>
        </S.Container>
    )
}
